import React, { useEffect, useState } from 'react';
import { obtenerNoticias, obtenerSubNews, obtenerArchivos } from '../AccionesBackend';

const WeddingPost = () => {
    const [noticiasList, setNoticiasList] = useState([]);
    const [subNews, setSubNews] = useState([]);
    const [imageUrl, setImageUrl] = useState(null);
    const [subNewsImages, setSubNewsImages] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // ✅ Obtener noticia principal
                const responseNoticia = await obtenerNoticias();
                
                if (responseNoticia && responseNoticia.status === "OK" && responseNoticia.noticias.length > 0) {
                    // ✅ Filtrar todas las noticias que tengan `activo = 1`
                    const noticiasActivas = responseNoticia.noticias.filter(n => parseInt(n.activo) === 1);
    
                    if (noticiasActivas.length > 0) {
                        setNoticiasList(noticiasActivas);
                    } else {
                        setError("No hay noticias activas.");
                    }
                } else {
                    setError("No hay noticias disponibles.");
                }
    
                // ✅ Obtener la imagen más reciente de la sección 22 (Noticia Principal)
                const responseImg = await obtenerArchivos({ seccionId: 22 });
                if (responseImg && responseImg.success && responseImg.archivos.length > 0) {
                    setImageUrl(responseImg.archivos[responseImg.archivos.length - 1].ruta_archivo);
                }
    
                // ✅ Obtener subnews de la sección 27
                const responseSubNews = await obtenerSubNews();
                if (responseSubNews && responseSubNews.status === "OK" && responseSubNews.subnews.length > 0) {
                    // Solo mostrar las que estén activadas (activo != 0)
                    const subNewsActivas = responseSubNews.subnews.filter(sub => parseInt(sub.activo) === 1 || sub.activo == null);
                    setSubNews(subNewsActivas);
                }
    
                // ✅ Obtener imágenes de la sección 27 (SubNews)
                const responseSubNewsImg = await obtenerArchivos({ seccionId: 27 });
                console.log(responseImg, "imagen subnews");
                if (responseSubNewsImg && responseSubNewsImg.success && responseSubNewsImg.archivos.length > 0) {
                    // Relacionamos `archivo_id` con `ruta_archivo`
                    const imageMap = {};
                    responseSubNewsImg.archivos.forEach((archivo) => {
                        imageMap[archivo.id] = archivo.ruta_archivo;
                    });
                    setSubNewsImages(imageMap);
                }
    
            } catch (error) {
                setError("Error al cargar los datos.");
                console.error("Error obteniendo datos:", error);
            } finally {
                setLoading(false);
            }
        };
    
        fetchData();
    }, []);
    

    if (loading) return <p>Cargando noticias...</p>;
    if (error) return <p style={{ color: "red" }}>{error}</p>;

    return (
        <div className="app-container">
            <div className="newspaper-layout">
                {/* ✅ Noticias principales */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}>
                    {noticiasList.map((noticiaItem) => (
                        <div key={noticiaItem.id} className="main-news">
                            <div className="post-header">
                                <div className="location">Durango, Dgo</div>
                                <div className="newspaper-title">Periódico IZZI</div>
                                <div className="date">{new Date(noticiaItem.date || new Date()).toLocaleDateString('es-MX')}</div>
                            </div>
                            <div className="main-heading">
                                <h1>{noticiaItem.title || "Título no disponible"}</h1>      
                                <p className="subtitle">{noticiaItem.subtitle || "Subtítulo no disponible"}</p>
                                <p className="author-name">Por {noticiaItem.author || "Autor desconocido"}</p>
                            </div>
                            <div className="image-wrapper">
                                {/* Asumiremos la misma imagen para todas si no la guardaste independiente, 
                                    lo ideal es usar noticiaItem.image si existe */}
                                <img src={noticiaItem.image || imageUrl || "https://via.placeholder.com/800x400"} alt="Noticia principal" />
                            </div>
                            <div className="article-content">
                                <div className="quote-block">
                                    “{noticiaItem.motivation || "Frase motivacional no disponible"}”
                                    <br />
                                    <span className="quote-author">-{noticiaItem.noticia || "No disponible"}</span>
                                </div>
                                <p className="welcome-message">
                                    {noticiaItem.content || "El contenido de la noticia no está disponible."}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

                {/* ✅ Subnews dinámicas */}
                <aside className="side-news">
                    {subNews.length > 0 ? (
                        subNews.map((sub, index) => (
                            <div key={index} className="side-news-item">
                                {/* Relacionar subnews.archivo_id con la imagen correcta */}
                                <img 
                                    src={subNewsImages[sub.archivo_id] || "https://via.placeholder.com/100x100"} 
                                    alt={sub.title} 
                                    style={{ width: "100%", height: "150px", objectFit: "cover", borderRadius: "8px" }} 
                                />
                                <h3>{sub.title}</h3>
                                <p>{sub.content}</p>
                            </div>
                        ))
                    ) : (
                        <p>No hay subnoticias disponibles.</p>
                    )}
                </aside>
            </div>
        </div>
    );
};

export default WeddingPost;
